import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useSetDefaultRole = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: async (roleId: string) => {
      const response = await fetch(
        `${APIBaseChronos}/api/roles/${roleId}/default`,
        getFetchConfig({ method: FetchMethod.PATCH }),
      );

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message ?? 'Failed to update default role');
      }
    },
    onSuccess: () => {
      // Setting a default also unsets the previous one, so refetch the whole list
      queryClient.invalidateQueries([QueryEntity.Roles]);
      toast.success('Default role updated');
    },
    onError: (error) => {
      toast.error(error.message ?? 'Failed to update default role');
    },
  });
};
